const state = {
    query: {
        q: "",
        numOnly: false,
        predmetiActiveName: "first",
        statusFilter: -1,
        obavezaFilter: -1,
        saradnikFilter: -1,
        nosiocFilter: -1
    }
};

const getters = {
    queryValue: state => state.query.q,
    queryFilterNumOnly: state => state.query.numOnly,
    predmetiActiveName: state => state.query.predmetiActiveName,
    searchStatusFilter: state => state.query.statusFilter,
    searchObavezaFilter: state => state.query.obavezaFilter,
    searchSaradnikFilter: state => state.query.saradnikFilter,
    searchNosiocFilter: state => state.query.nosiocFilter,
};

const actions = {
    setQuery({ commit }, q) {
        commit('setQuery', q)
    },
    toggleFilterNumOnly({ commit }) {
        commit('toggleFilterNumOnly')
    },
    togglePredmetiActiveName({ commit }) {
        commit('togglePredmetiActiveName')
    },
    updateStatusFilter({ commit }, v) {
        commit('updateStatusFilter', v)
    },
    updateObavezaFilter({ commit }, v) {
        commit('updateObavezaFilter', v)
    },
    updateSaradnikFilter({ commit }, v) {
        commit('updateSaradnikFilter', v)
    },
    updateNosiocFilter({ commit }, v) {
        commit('updateNosiocFilter', v)
    }
};

const mutations = {
    setQuery: (state, q) => state.query.q = q,
    toggleFilterNumOnly: (state) => state.query.numOnly = !state.query.numOnly,
    togglePredmetiActiveName: (state) => state.query.predmetiActiveName = (state.query.predmetiActiveName == "first" ? "second" : "first"),
    updateStatusFilter: (state, v) => state.query.statusFilter = v,
    updateObavezaFilter: (state, v) => state.query.obavezaFilter = v,
    updateSaradnikFilter: (state, v) => state.query.saradnikFilter = v,
    updateNosiocFilter: (state, v) => state.query.nosiocFilter = v
};

export default {
    state,
    getters,
    actions,
    mutations
};